import { logger, addInstrumentationHandler } from '@sentry/utils';
import { WINDOW } from './types.js';
/**
 * Default function implementing pageload and navigation transactions
 */

function instrumentRoutingWithDefaults(customStartTransaction) {
  var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!WINDOW || !WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  var startingUrl = WINDOW.location.href;
  var activeTransaction;

  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: WINDOW.location.pathname,
      op: 'pageload',
      metadata: {
        source: 'url'
      }
    });
  }

  if (startTransactionOnLocationChange) {
    addInstrumentationHandler('history', function (_ref) {
      var to = _ref.to,
          from = _ref.from;

      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;

        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("[Tracing] Finishing current transaction with op: ".concat(activeTransaction.op)); // If there's an open transaction on the scope, we need to finish it before creating an new one.

          activeTransaction.finish();
        }

        activeTransaction = customStartTransaction({
          name: WINDOW.location.pathname,
          op: 'navigation',
          metadata: {
            source: 'url'
          }
        });
      }
    });
  }
}

export { instrumentRoutingWithDefaults };